import _createClass from "@babel/runtime/helpers/createClass";
import base64 from './base64';

var File_ = /*#__PURE__*/function () {
  function File_(file) {
    this.file = file;
  }
  /**
   * 文件下载
   * @param {Object} blob 
   * @param {String} name 
   * @文档地址 https://gtcloud.yuque.com/asfzgp/trhc08/gnp1ur#pPoLc
   */


  File_.download = function download(blob, name) {
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, decodeURI(name));
    } else {
      var a = document.createElement('a');
      var url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = decodeURI(name);
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }
  /**
   * 将base64转换为文件
   * @param {String} dataURL 文件dataURL
   * @param {String} name 文件名
   */
  ;

  File_.dataURLtoFile = function dataURLtoFile(dataURL, name) {
    var _dataURL$split = dataURL.split(','),
        header = _dataURL$split[0],
        content = _dataURL$split[1]; // 文件mine类型


    var _header$match = header.match(/:(.*?);/),
        mine = _header$match[0]; // 对base64进行反编码
    // str = window.atob(content);


    var str = base64.decode(content); // 进行编码

    var n = str.length;
    var u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = str.charCodeAt(n);
    } // 创建文件


    var file = new File([u8arr], name, {
      type: mine
    });
    return new this(file);
  }
  /**
   * 
   * @param {Object} blob 
   * @param {String} name 
   * @param {?Object} options 
   */
  ;

  File_.blobToFile = function blobToFile(blob, name, options) {
    // 创建文件
    var file = new File(blob, name, options);
    return new this(file);
  }
  /**
   * base64转换成blob
   * @param {String} dataURL 
   */
  ;

  File_.dataURLtoBlob = function dataURLtoBlob(dataURL) {
    var _dataURL$split2 = dataURL.split(','),
        mineString = _dataURL$split2[0],
        baseString = _dataURL$split2[1]; // 解码base64


    var str = base64.decode(baseString); // 获取mineType

    var mineType = mineString.split(':')[1].split(';')[0]; // 生成arrayBuffer

    var ab = new ArrayBuffer(str.length);
    var ia = new Uint8Array(ab); // 循环获取unicode插入

    for (var i = 0; i < str.length; i++) {
      ia[i] = str.charCodeAt(i);
    }

    return new Blob([ab], {
      type: mineType
    });
  }
  /**
   * 获取文件扩展名
   */
  ;

  var _proto = File_.prototype;

  /**
   * 将文件转换为base64
   * 即dataURL
   */
  _proto.readFileAsType = function readFileAsType(type) {
    if (type === void 0) {
      type = 'URL';
    }

    var reader = new FileReader(); // 如果读取为base64

    if (type === 'URL') {
      reader.readAsDataURL(this.file);
    } else if (type === 'buffer') {
      reader.readAsArrayBuffer(this.file);
    } else if (type === 'string') {
      reader.readAsText(this.file);
    } else if (type === 'binary') {
      reader.readAsBinaryString(this.file);
    } else {
      reader.readAsDataURL(this.file);
    }

    return new Promise(function (resolve) {
      reader.onload = function (event) {
        resolve(event.target.result);
      }; // reader.onload((event: any): void => {
      //   resolve(event.target.result);
      // });

    });
  };

  _createClass(File_, [{
    key: "ext",
    get: function get() {
      return this.file.name.split('.').pop().toLowerCase();
    },
    set: function set(value) {
      this.file.name = this.file.name.replace(/\.[\w\d]$/, "." + value);
    }
    /**
     * 获取文件大小
     */

  }, {
    key: "mbSize",
    get: function get() {
      return this.file.size / 1024 / 1024;
    }
  }]);

  return File_;
}();

export { File_ as default };